import React, { useState, useEffect, useRef } from 'react';
import { Form, InputNumber, Spin, Input, DatePicker, message } from 'antd';
import { useHistory, useParams } from 'react-router-dom';
import { Config } from '../../public/js/config';
import { Base } from '../../public/js/base';
import context from '../../public/js/context';
import moment from 'moment';//日期格式化导包
import { studentCheckLogin } from '../newMain/studentMain';

import NewMessage from '../../component/newMessage/newMessage';
import './studentFillWPA.css'
import saveImg from '../../public/img/newMain/Save.png';
import stdApplyJobAdd from '../../public/img/std/stdApplyJobAdd.png';
import MessagesTop from '../../component/messagesTop/messagesTop';

const StudentFillWPA = (props) => {

    const studentModuleId = localStorage.getItem(Config.tokenPrefix + 'studentModuleId');
    const { wpaApplId } = useParams();
    const messageRef = useRef();
    const history = useHistory();
    const [status, setStatus] = useState('')
    const [isLoad, setIsLoad] = useState(false);
    const [isFromDate, setIsFromDate] = useState(false);
    const [isToDate, setIsToDate] = useState(false);
    const [form] = Form.useForm();
    const [wpaApplModel, setWpaApplModel] = useState({});
    const messageTopRef = useRef();

    useEffect(() => {
        if (!Config.studentInfo?.studentId) {
            studentCheckLogin();
        }
        if(wpaApplId){
            searchById();
        } else {
            searchModuleById();
        }
    }, []);

    const searchById = (id) => {
        let model = {
            studentModuleId : studentModuleId,
            wpaApplId : id ? id : wpaApplId
        };
        Base.callBackApi("wpaAppl/searchById", model).then((data) => {
            if ("SUCCESS" === data?.msg) {
                let model = data?.object ?? {};
                setWpaApplModel(model);
                initForm(model);
            } else {
                console.log(data?.msg)
            }
        })
    }

    const searchModuleById = () => {
        let model = {
            studentModuleId : studentModuleId,
            studentId : Config.studentInfo?.studentId
        };
        Base.callBackApi("studentModule/searchById", model).then((data) => {
            if ("SUCCESS" === data?.msg) {
                let model = data?.object ?? {};
                setWpaApplModel(model);
                initForm(model);
            } else {
                console.log(data?.msg)
            }
        })
    }

    const initForm = (model = {}) => {
        form.resetFields();
        form.setFieldsValue({
            wilHours: model.wilHours ?? "",
            periodStartDate: model?.periodStartDate ? moment(model?.periodStartDate) : null,
            periodEndDate: model?.periodEndDate ? moment(model?.periodEndDate) : null,
            companyName: model?.companyName ?? '',
            companyAddress: model?.companyAddress ?? '',
            industrySupervisorName: model?.industrySupervisorName ?? '',
            industrySupervisorPosition: model?.industrySupervisorPosition ?? '',
            industrySupervisorPhone: model?.industrySupervisorPhone ?? '',
            industrySupervisorEmail: model?.industrySupervisorEmail ?? '',
        });

        if(model?.wpaStatus == 'RETURNED_TO_STUDENT' && model?.eventRemark) {
            messageTopRef.current.setContent('Returned to Student Reason: ' + model?.eventRemark);
            messageTopRef.current.setIsShow(true);
        }
    }

    /** 生成提示信息 */
    const errFrameShow = (msg) => {
        messageRef.current.setIsShow(true);
        messageRef.current.setContent(msg);
    }

    const done = () => {
        messageRef.current.setIsShow(false)
        if(wpaApplModel?.wpaStatus == 'DRAFT') {
            history.replace('/student/studentFillWPA/' + wpaApplModel.wpaApplId);
        } else {
            localStorage.setItem(Config.tokenPrefix + 'wpaApplId', wpaApplModel.wpaApplId);
            history.replace('/student/reviewWPAFormDetail');
        }
    }

    const submit = () => {
        setStatus('PENDING_SEND');
        form.submit();
    }

    const draft = () => {
        setStatus('DRAFT');
        form.submit();
    }

    const onFinish = (values) => {
        if (isLoad) {
            return;
        }
        setIsLoad(true);
        let model = {...values, wpaStatus: status, studentModuleId: studentModuleId};
        let url;
        if (wpaApplModel.wpaApplId) {
            url = "wpaAppl/update"
            model.wpaApplId = wpaApplModel.wpaApplId;
            model.lastUpdatedDate = wpaApplModel.lastUpdatedDate;
        } else {
            url = "wpaAppl/insert"
        }
        Base.callBackApi(url, model).then((data) => {
            if ("SUCCESS" === data.msg) {
                let model = data.object ?? {};
                setWpaApplModel(m => (
                    { ...m, ...model }
                ))
                searchById(model.wpaApplId);
                if (model.wpaStatus == 'DRAFT') {
                    errFrameShow("Your WPA form is now saved as a draft only. Please remember to submit the form to proceed with the assessment process.")
                } else {
                    errFrameShow("You've completed your part in the WPA form. This form will be sent to the academic supervisor for review.")
                }
            } else {
                message.error(data.msg)
            }
        }).catch(err => { }).finally(() => setIsLoad(false));
    }

    const checkWilHour = (value) => {
        if (Base.isEmpty(value)) {
            return Promise.reject("Total WIL Hours is required.");
        }
        if (value && !/^\d{1,3}(\.\d{1,2})?$/.test(value)) {
            return Promise.reject(new Error('Total WIL Hours cannot be greater than 999.9'));
        }
        return Promise.resolve();
    }

    const checkStartDate = (value) => {
        if (Base.isEmpty(value)) {
            return Promise.reject("Period Start Date is required.");
        }
        if (Base.isNotEmpty(value)) {
            const endDate = form.getFieldValue('preriodEndDate')
            if (Base.isNotEmpty(endDate)) {
                if (Base.afterDate(value, endDate)) {
                    if (!isToDate) {
                        setIsToDate(true);
                        form.validateFields(["preriodEndDate"]);
                    }
                    return Promise.reject("Period Start Date cannot be later than Period End Date. ")
                }
            }
        }
        if (isToDate) {
            form.validateFields(["preriodEndDate"]);
        }
        setIsToDate(false);
        return Promise.resolve();
    }

    const checkEndDate = (value) => {
        if (Base.isEmpty(value)) {
            return Promise.reject("Period End Date is required.");
        }
        if (Base.isNotEmpty(value)) {
            const startDate = form.getFieldValue('periodStartDate')
            if (Base.isNotEmpty(startDate)) {
                if (Base.afterDate(startDate, value)) {
                    if (!isFromDate) {
                        setIsFromDate(true);
                        form.validateFields(["periodStartDate"]);
                    }
                    return Promise.reject("Period End Date cannot be earlier than Period Start Date.")
                }
            }
        }
        if (isFromDate) {
            form.validateFields(["periodStartDate"]);
        }
        setIsFromDate(false);
        return Promise.resolve();
    }

    return (
        <div id="container" className='websiteTemplate studentFillWPA'>
            <NewMessage ref={messageRef} done={done} />
            <Spin size="large" spinning={isLoad} >
                <div className='websiteSysButtonRow'>
                    <div className='detailStatusBox'>
                        <div className="detailTitle" >
                            Fill in WPA Form
                        </div>
                        {context.wpaFormStatusMap.map(item => item.value === wpaApplModel?.wpaStatus && <div key={item.value} className={'statusTitleBox ' + item.value}>{item.label}</div>)}
                    </div>
                    <div className="websiteSysButtonBox">
                        {(!wpaApplModel?.wpaStatus || wpaApplModel?.wpaStatus == 'DRAFT') && <div className='websiteSysButton draftButton' onClick={() => draft()}><img src={saveImg} />Draft</div>}
                        <div className='websiteSysButton' onClick={() => submit()}><img src={stdApplyJobAdd} />Submit</div>
                    </div>
                </div>
                <MessagesTop ref={messageTopRef} />
                <div className='websiteSysContentBox'>
                    <Form form={form} onFinish={onFinish}>
                        <div className='contentTitle'>
                            Part I – Information of Student & WIL Partner
                        </div>
                        <div className='contentTitle'>
                            Student Information
                        </div>
                        <div className="websiteSysRow">
                            <div className="websiteSysCol">
                                <div className="websiteSysParam ">Student Name</div>
                                <div className="websiteSysInput">
                                    <Input type="text" placeholder="Student Name" disabled value={wpaApplModel?.firstName + ' ' + wpaApplModel?.lastName} />
                                </div>
                            </div>
                            <div className="websiteSysCol">
                                <div className="websiteSysParam ">Student ID</div>
                                <div className="websiteSysInput">
                                    <Input type="text" placeholder="Student ID" disabled value={wpaApplModel?.studentAcctId} />
                                </div>
                            </div>
                        </div>
                        <div className="websiteSysRow">
                            <div className="websiteSysCol">
                                <div className="websiteSysParam ">Programme Title</div>
                                <div className="websiteSysInput">
                                    <Input type="text" placeholder="Programme Title" disabled value={wpaApplModel?.progTitle} />
                                </div>
                            </div>
                            <div className="websiteSysCol">
                                <div className="websiteSysParam ">WIL Module Code</div>
                                <div className="websiteSysInput">
                                    <Input type="text" placeholder="WIL Module Code" disabled value={wpaApplModel?.moduleCode}  />
                                </div>
                            </div>
                        </div>
                        <div className="websiteSysRow">
                            <div className="websiteSysCol">
                                <div className="websiteSysParam ">WIL Module Title</div>
                                <div className="websiteSysInput">
                                    <Input type="text" placeholder="WIL Module Title" disabled value={wpaApplModel?.moduleName} />
                                </div>
                            </div>
                            <div className="websiteSysCol">
                                <div className="websiteSysParam mustFill">Total WIL Hours</div>
                                <div className="websiteSysInput">
                                    <Form.Item
                                        name="wilHours"
                                        rules={[
                                            { required: true, validator: (rule, value) => checkWilHour(value) },
                                        ]}
                                    >
                                        <InputNumber precision={1} maxLength={5} min={0} placeholder="Total WIL Hours" disabled={wpaApplModel?.wpaStatus == 'PENDING_SEND'} />
                                    </Form.Item>
                                </div>
                            </div>
                        </div>
                        <div className="websiteSysRow">
                            <div className="websiteSysCol">
                                <div className="websiteSysParam mustFill">WIL Period</div>
                                <div className="websiteSysInput dateInput">
                                    <Form.Item
                                        name="periodStartDate"
                                        rules={[
                                            { required: true, validator: (rule, value) => checkStartDate(value) },
                                        ]}
                                    >
                                        <DatePicker placeholder="Start Date"
                                            className="parts-numberInput datePickerAllWidth"
                                            format={Config.dateFormatEn}
                                            getPopupContainer={(triggerNode) => triggerNode.parentNode} disabled={wpaApplModel?.wpaStatus == 'PENDING_SEND'} />
                                    </Form.Item>
                                    <div style={{ width: "10px" }}>-</div>
                                    <Form.Item
                                        name="periodEndDate"
                                        rules={[
                                            { required: true, validator: (rule, value) => checkEndDate(value) },
                                        ]}
                                    >
                                        <DatePicker placeholder="End Date"
                                            className="parts-numberInput datePickerAllWidth"
                                            format={Config.dateFormatEn}
                                            getPopupContainer={(triggerNode) => triggerNode.parentNode} disabled={wpaApplModel?.wpaStatus == 'PENDING_SEND'} />
                                    </Form.Item>
                                </div>
                            </div>
                            <div className="websiteSysCol"></div>
                        </div>
                        <div className='contentTitle'>
                            Host Company/ Organisation Information
                        </div>
                        <div className="websiteSysRow">
                            <div className="websiteSysCol">
                                <div className="websiteSysParam mustFill">Company/ Organisation Name</div>
                                <div className="websiteSysInput">
                                    <Form.Item
                                        name="companyName"
                                        rules={[
                                            { required: true, message: "Company/ Organisation Name is required." },
                                        ]}
                                    >
                                        <Input type="text" placeholder="Company/ Organisation Name" maxLength={100} disabled={wpaApplModel?.wpaStatus == 'PENDING_SEND'} />
                                    </Form.Item>
                                </div>
                            </div>
                            <div className="websiteSysCol">
                                <div className="websiteSysParam mustFill">Company/ Organisation Address</div>
                                <div className="websiteSysInput">
                                    <Form.Item
                                        name="companyAddress"
                                        rules={[
                                            { required: true, message: "Company/ Organisation Address is required." },
                                        ]}
                                    >
                                        <Input type="text" placeholder="Company/ Organisation Address" maxLength={400} disabled={wpaApplModel?.wpaStatus == 'PENDING_SEND'} />
                                    </Form.Item>
                                </div>
                            </div>
                        </div>
                        <div className='contentTitle'>
                            Industry Supervisor Information
                        </div>
                        <div className="websiteSysRow">
                            <div className="websiteSysCol">
                                <div className="websiteSysParam mustFill">Name</div>
                                <div className="websiteSysInput">
                                    <Form.Item
                                        name="industrySupervisorName"
                                        rules={[
                                            { required: true, message: "Name is required." },
                                        ]}
                                    >
                                        <Input type="text" placeholder="Name" maxLength={50} disabled={wpaApplModel?.wpaStatus == 'PENDING_SEND'} />
                                    </Form.Item>
                                </div>
                            </div>
                            <div className="websiteSysCol">
                                <div className="websiteSysParam mustFill">Position</div>
                                <div className="websiteSysInput">
                                    <Form.Item
                                        name="industrySupervisorPosition"
                                        rules={[
                                            { required: true, message: "Position is required." },
                                        ]}
                                    >
                                        <Input type="text" placeholder="Position" maxLength={50} disabled={wpaApplModel?.wpaStatus == 'PENDING_SEND'} />
                                    </Form.Item>
                                </div>
                            </div>
                        </div>
                        <div className="websiteSysRow">
                            <div className="websiteSysCol">
                                <div className="websiteSysParam mustFill">Telephone Number</div>
                                <div className="websiteSysInput">
                                    <Form.Item
                                        name="industrySupervisorPhone"
                                        rules={[
                                            { required: true, message: "Telephone Number is required." },
                                        ]}
                                    >
                                        <InputNumber placeholder="Telephone Number" maxLength={12} disabled={wpaApplModel?.wpaStatus == 'PENDING_SEND'} />
                                    </Form.Item>
                                </div>
                            </div>
                            <div className="websiteSysCol">
                                <div className="websiteSysParam mustFill">Email Address</div>
                                <div className="websiteSysInput">
                                    <Form.Item
                                        name="industrySupervisorEmail"
                                        rules={[
                                            { required: true, message: 'Email Address is required.' },
                                            { pattern: /^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,4}$/, message: 'Incorrect Email format.' },
                                        ]}
                                    >
                                        <Input type="text" placeholder="Email Address" maxLength={50} disabled={wpaApplModel?.wpaStatus == 'PENDING_SEND'} />
                                    </Form.Item>
                                </div>
                            </div>
                        </div>
                    </Form>
                </div>
                <div className="websiteSysButtonBox">
                    {(!wpaApplModel?.wpaStatus || wpaApplModel?.wpaStatus == 'DRAFT') && <div className='websiteSysButton draftButton' onClick={() => draft()}><img src={saveImg} />Draft</div>}
                    <div className='websiteSysButton' onClick={() => submit()}><img src={stdApplyJobAdd} />Submit</div>
                </div>
            </Spin>
        </div>
    )

}

export default StudentFillWPA;